import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    bannerContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    },
    imageContainer: {
        height: 530,
        maxWidth: 960,
        margin: '40px auto',
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            marginTop: 0,
            height: 'fit-content'
        }
    },
    imageBox: {
        width: '40%',
        height: '100%'
    },
    image: {
        height: '100%'
    },
    imageTextBox: {
        width: '60%',
        height: '100%',
        backgroundColor: 'var(--background-purple)',
        borderLeft: '3px solid var(--background-black)',
        padding: '100px 20px 100px 50px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 40,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: 400,
            padding: '40px 20px 40px 20px',
            borderTop: '3px solid var(--background-black)',
            borderLeft: 'unset'
        }
    },
    titlePage: {
        fontSize: 55,
        width: 440,
        color: 'white',
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            width: 300,
            fontSize: 40
        }
    },
    subtitlePage: {
        fontSize: 28,
        color: 'white'
    },
    imageText: {

    },

    keyInfoContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 12,
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    },
    keyInfoLeftSideContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '60%',
        gap: 20,
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    keyInfoLeftSide: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12
    },
    registrationButtonBox1: {
        marginTop: 20,
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            justifyContent: 'center'
        }
    },
    registrationButtonBox2: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20
    },
    extraInfoContainer: {
        backgroundColor: 'var(--background-blue)',
        padding: '50px 100px',
        borderRadius: 'var(--border-radius)',
        [theme.breakpoints.down('sm')]: {
            padding: 20
        }
    },
    fontSize16: {
        fontSize: 16
    },
    spanBold: {
        fontWeight: 'bold'
    },
    keyInfoRightSide: {
        display: 'flex',
        flexDirection: 'column',
        width: '40%',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    mapContainer: {

    },
    mapBox: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    },
    mapImage: {
        height: 500,
        [theme.breakpoints.down('sm')]: {
            height: 'unset',
            width: '100%'
        }
    },
    companyCardBox: {
        scrollSnapAlign: 'center',
        width: '100%',
        minWidth: 370,
        [theme.breakpoints.down('xs')]: {
            minWidth: 300
        }
    },
    pipedriveSchedule: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 100
    },
    pipedriveScheduleFrame: {
        height: 700,
        width: '100%',
        maxWidth: '800px',
        borderRadius: 'var(--border-radius)',
        [theme.breakpoints.down('xs')]: {
            height: 1150
        }
    }
}))
